export const colorsBackground = [
  '#0004FB',
  '#FF5930',
  '#373E7C',
  '#26B999',
  '#D92E68',
  '#009FFB',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
